import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="relative bg-gradient-to-r from-[#0A0E2A] via-[#0d1530] to-[#0A0E2A] border-b border-gold-500/30 overflow-hidden" data-id="element-362">
      {/* subtle shimmer accent */}
      <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-[200%] h-full bg-[radial-gradient(ellipse_at_center,_rgba(201,168,76,0.12)_0%,_transparent_60%)] pointer-events-none" data-id="element-363" />

      <div className="relative max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-364">
        <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-365">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold-400 opacity-75" data-id="element-366" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-gold-500" data-id="element-367" />
        </span>

        <SparklesIcon className="w-4 h-4 text-gold-400 flex-shrink-0 hidden sm:block" data-id="element-368" />

        <p className="text-xs sm:text-sm text-white font-medium tracking-wide" data-id="element-369">
          <span className="text-gold-400 uppercase tracking-widest font-semibold" data-id="element-370">
            Oferta de Lanzamiento
          </span>
          <span className="hidden sm:inline mx-2 text-cream-muted" data-id="element-371">•</span>
          <span className="block sm:inline" data-id="element-372">
            <span className="text-cream-muted" data-id="element-373">Solo hoy a </span>
            <span className="text-gold-400 font-semibold" data-id="element-374">$17 USD</span>
            <span className="text-cream-muted line-through ml-2 decoration-gold-500/60" data-id="element-375">
              $97
            </span>
          </span>
        </p>
      </div>
    </div>;
}